import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { SharedService } from "../store/shared-store/shared-storage.service";
import { Observable } from "rxjs";
import {map, retry} from "rxjs/operators";
import {NodeObject, NodeSupportedChannels} from "../../../shared/utils/nodeTypes";

const CHAT_HUB_BASE_URI = "chat-hub"

@Injectable({
    providedIn: 'root'
})
export class ChatHubService {
    chatHubData: any[] = [];

    constructor(private http: HttpClient, private sharedService: SharedService) {
    }

    setChatHubData(data) {
        this.chatHubData = data;
    }

    getChatHubData() {
        return this.chatHubData;
    }

    private buildUri(paths: string[]) {
        const baseUri = [
            environment.controlBaseUrl,
            CHAT_HUB_BASE_URI,
            this.sharedService.getEntityType(),
            this.sharedService.getEntityId(),
            ...paths
        ];
        return baseUri.join("/");
    }

    public getProviders(): Observable<NodeObject[]> {
        const path: string[] = ["providers"]
        return this.http.get<any>(this.buildUri(path)).pipe(
            retry(2),
            map((providers: NodeObject[]) =>
                providers.map(provider => {
                        const nodeObject: NodeObject = {
                            type: "action",
                            nodeType: 'chatHub',
                            image: {
                                primary: provider['logoUrl'],
                                fallback: '/assets/svg/redesign/nodes/right-panel/chatHub_rsb_fallback.svg'
                            },
                            sortType: "",
                            count: 0,
                            description: provider["description"],
                            canvas: {
                                icon: '/assets/svg/redesign/nodes/canvas-icons/chatHub_canvas_fallback.svg',
                                backgroundImg: "",
                                backgroundImgHover: "",
                                backgroundImgSelected: "",
                            },
                            title: provider["name"],
                            supported_channel: NodeSupportedChannels.ALL,
                            nodeInfoSrc: provider["moreInfoUrl"],
                            extraFields: {
                                providerId: provider["id"],
                                imageUrl: provider["logoUrl"],
                            }
                        }
                        return nodeObject
                    }
                )
            )
        )
    }

    public getProviderApis(providerId: string): Observable<any> {
        const path: string[] = ["providers", providerId, "apis"]
        return this.http.get<any>(this.buildUri(path));
    }

    public getProviderInstances(providerId: string): Observable<any> {
        const path: string[] = [providerId, "instances"]
        return this.http.get<any>(this.buildUri(path)).pipe(
            map(instances => {
                return instances.map(instance => ({
                    id: instance.id,
                    displayName: instance.displayName ? instance.displayName : instance.name
                }));
            })
        );
    }

    public getProviderApiDetails(providerId: string, apiId: string): Observable<any> {
        const path: string[] = [providerId, "apis", apiId]
        return this.http.get<any>(this.buildUri(path));
    }
}
